import { Directive, forwardRef } from '@angular/core';
import { NG_VALIDATORS, Validator, AbstractControl } from '@angular/forms';
import {ValidateAccountNumber} from '../iban.validator';

@Directive({
  selector: '[app-iban][ngModel]',
  providers: [{ provide: NG_VALIDATORS, useExisting: forwardRef(() => IbanValidatorDirective), multi: true }]
})

export class IbanValidatorDirective implements Validator {

  validate(control: AbstractControl): { [key: string]: any } {
    return ValidateAccountNumber(control);
  }
}
